module.exports = __webpack_public_path__ + "img/camera.cc3fb23e.png";